import { WizMathUtils } from '@wizeoo/akm-core-lib';
import { WeightGrid, WeightGridKey, WeightGridLine } from '@wizeoo/akm-message-lib';
import { Model } from '../../model/model';

/**
 * VO représentant une grille de poids
 * Réduit à son minimum pour utilisation par le moteur
 */
export class WeightGridVO {

    protected _model: Model = null;
    public get model(): Model {
      return this._model as Model;
    } 
    
    constructor(model: Model, pSource?: WeightGrid) {
        this._model = model;
        this._source = null;
        if (pSource) {
            this._source = pSource;
        } else {
            this._source = new WeightGrid();
            this._source.uid = WizMathUtils.createUUID(); // génération du UID si nouveau
        }
    }

    /** L'objet source provenant du back */
    private _source: WeightGrid;

    public get source(): WeightGrid {
        return this._source;
    }
    public set source(value: WeightGrid) {
        this._source = value;
    }

    public set code(value: string) {
        this._source.code = value;
    }
    public get code(): string {
        return this._source.code;
    }

    /* ################################################
     *                Accesseurs composites
     * ################################################ */

    public get weightGridKeys(): WeightGridKey[] {
        return this._source.weightGridKeys;
    }

    public get weightGridLines(): WeightGridLine[] {
        return this._source.weightGridLines;
    }

}
